import { render, staticRenderFns } from "./already-using.vue?vue&type=template&id=7127174a&scoped=true"
var script = {}
import style0 from "./already-using.vue?vue&type=style&index=0&id=7127174a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127174a",
  null
  
)

export default component.exports